
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { getAndClearRedirectPath } from '@/utils/auth-redirect';

const AuthRedirect = () => {
  const { user, activeRole, roleReady } = useAuth();
  
  console.log('AuthRedirect: user:', !!user, 'activeRole:', activeRole, 'roleReady:', roleReady);
  
  if (!user) {
    console.log('AuthRedirect: No user, redirecting to home');
    return <Navigate to="/" replace />;
  }
  
  // Wait for role to be determined before redirecting
  if (!roleReady) {
    console.log('AuthRedirect: Role not ready, waiting...');
    return null; // Or a loading spinner
  }
  
  // Check for saved redirect path first
  const savedPath = getAndClearRedirectPath();
  
  if (activeRole === 'client') {
    console.log('AuthRedirect: Redirecting to', savedPath || '/client-dashboard');
    return <Navigate to={savedPath || '/client-dashboard'} replace />;
  } else if (activeRole === 'practitioner') {
    console.log('AuthRedirect: Redirecting to', savedPath || '/practitioner-dashboard');
    return <Navigate to={savedPath || '/practitioner-dashboard'} replace />;
  } else if (activeRole === 'admin') {
    console.log('AuthRedirect: Redirecting to', savedPath || '/admin/dashboard');
    return <Navigate to={savedPath || '/admin/dashboard'} replace />;
  }
  
  console.log('AuthRedirect: No valid role found, redirecting to home');
  return <Navigate to="/" replace />;
};

export default AuthRedirect;

